import axios from './axios';

export default {
  update: (params) => axios.put(`/form_answer_type_connectivites/${params.id}`, {
    form_answer_type_connectivite: params,
  }),
};
